module.exports = __webpack_public_path__ + "img/zhongbangImg.11c0ffab.png";